module.exports = __webpack_public_path__ + "img/mailchimp-logo.3bccac72.png";